
export default {
    name: "Faq",
    props: {
        blok: {
            type: Object,
            required: true,
        },
    },
}
